module.exports = __webpack_public_path__ + "static/media/lose.d53c7f96.ogg";